import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

interface ContractFormProps {
  onSubmit: () => void;
  disabled?: boolean;
  loading?: boolean;
}

const ContractForm: React.FC<ContractFormProps> = ({ onSubmit, disabled = false, loading = false }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
      <Button
        variant="contained"
        color="primary"
        startIcon={loading ? undefined : <PlayArrowIcon />}
        onClick={onSubmit}
        disabled={disabled || loading}
      >
        {loading ? <CircularProgress size={20} color="inherit" /> : 'Analyze Contract'}
      </Button>
    </Box>
  );
};

export default ContractForm;